// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-page {
  --brand: rgb(0, 65, 149);
  --brand-dark: rgb(0, 48, 112);
  --surface: #F5F8FF;
  --surface-2: #EEF3FC;
  --border: #E2E8F4;
  --ink: #172B4D;
  --muted: #4B5768;
  --success: #1F9D6B;
  --warning: #C08A1E;
  --danger: #C24444;
  --r: 12px;
  --rsm: 8px;
  --rxs: 6px;
  padding: 24px;
  min-height: 100%;
  background: #fff;
  font-family: "Inter", sans-serif;
}
.dashboard-page .dashboard-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 28px;
  flex-wrap: wrap;
}
.dashboard-page .dashboard-heading h1 {
  margin: 0;
  color: var(--ink);
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 26px;
  letter-spacing: -0.01em;
}
.dashboard-page .dashboard-heading p {
  margin: 6px 0 0;
  color: var(--muted);
  font-size: 14px;
}
.dashboard-page .dashboard-heading .dashboard-heading-actions,
.dashboard-page .dashboard-heading .dashboard-view-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.dashboard-page .dashboard-heading .dashboard-refresh-button,
.dashboard-page .dashboard-heading .dashboard-view-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  color: var(--brand-dark);
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: 999px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
}
.dashboard-page .dashboard-heading .dashboard-refresh-button:hover, .dashboard-page .dashboard-heading .dashboard-refresh-button:focus-visible,
.dashboard-page .dashboard-heading .dashboard-view-button:hover,
.dashboard-page .dashboard-heading .dashboard-view-button:focus-visible {
  color: var(--brand);
  border-color: var(--brand);
  outline: none;
}
.dashboard-page .dashboard-heading .dashboard-view-button.is-active {
  color: #fff;
  background: var(--brand);
  border-color: var(--brand);
}
.dashboard-page .dashboard-panel {
  margin-bottom: 24px;
  border-radius: var(--r);
  border: 1px solid var(--border);
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 35, 75, 0.05);
}
.dashboard-page .dashboard-panel .ant-card-head {
  border-bottom: 1px solid var(--border);
}
.dashboard-page .dashboard-panel .ant-card-head .ant-card-head-title {
  font-family: "Inter", sans-serif;
  font-weight: 600;
  color: var(--ink);
  font-size: 15px;
}
.dashboard-page .dashboard-kanban {
  display: flex;
  gap: 16px;
  align-items: start;
  padding-bottom: 10px;
  overflow-x: auto;
  overscroll-behavior-x: contain;
}
.dashboard-page .kanban-column {
  flex: 0 0 280px;
  min-width: 280px;
  overflow: hidden;
  border: 1px solid var(--border);
  border-radius: var(--r);
  background: var(--surface);
}
.dashboard-page .kanban-column-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 15px 16px;
  color: var(--brand-dark);
  background: var(--surface-2);
  border: 0;
  border-bottom: 1px solid var(--border);
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  text-align: left;
  cursor: pointer;
  transition: filter 0.15s ease;
}
.dashboard-page .kanban-column:nth-child(1) .kanban-column-header {
  background: #e8f0ff;
}
.dashboard-page .kanban-column:nth-child(2) .kanban-column-header {
  background: #e8f8f1;
}
.dashboard-page .kanban-column:nth-child(3) .kanban-column-header {
  background: #fff3df;
}
.dashboard-page .kanban-column:nth-child(4) .kanban-column-header {
  background: #f4eaff;
}
.dashboard-page .kanban-column:nth-child(5) .kanban-column-header {
  background: #ffe9ec;
}
.dashboard-page .kanban-column:nth-child(6) .kanban-column-header {
  background: #e5f7fb;
}
.dashboard-page .kanban-column:nth-child(7) .kanban-column-header {
  background: #eef1d8;
}
.dashboard-page .kanban-column:nth-child(8) .kanban-column-header {
  background: #fce8d9;
}
.dashboard-page .kanban-column:nth-child(9) .kanban-column-header {
  background: #e9e7ff;
}
.dashboard-page .kanban-column:nth-child(10) .kanban-column-header {
  background: #e5f0e5;
}
.dashboard-page .kanban-column:nth-child(11) .kanban-column-header {
  background: #fff0f5;
}
.dashboard-page .kanban-column:nth-child(12) .kanban-column-header {
  background: #e6f5ff;
}
.dashboard-page .kanban-column:nth-child(13) .kanban-column-header {
  background: #f3edda;
}
.dashboard-page .kanban-column:nth-child(14) .kanban-column-header {
  background: #e7eff4;
}
.dashboard-page .kanban-column:nth-child(15) .kanban-column-header {
  background: #f6e8d5;
}
.dashboard-page .kanban-column:nth-child(16) .kanban-column-header {
  background: #e8eefa;
}
.dashboard-page .kanban-column:nth-child(17) .kanban-column-header {
  background: #e9f5e9;
}
.dashboard-page .kanban-column:nth-child(18) .kanban-column-header {
  background: #f8e9e9;
}
.dashboard-page .kanban-column:nth-child(19) .kanban-column-header {
  background: #eee9fa;
}
.dashboard-page .kanban-column:nth-child(20) .kanban-column-header {
  background: #e7f3f0;
}
.dashboard-page .kanban-column:nth-child(21) .kanban-column-header {
  background: #e6eaf7;
}
.dashboard-page .kanban-column:nth-child(22) .kanban-column-header {
  background: #f5eadf;
}
.dashboard-page .kanban-column:nth-child(23) .kanban-column-header {
  background: #e4f4ec;
}
.dashboard-page .kanban-column:nth-child(24) .kanban-column-header {
  background: #f1e8f8;
}
.dashboard-page .kanban-column:nth-child(25) .kanban-column-header {
  background: #e8f2f5;
}
.dashboard-page .kanban-column:nth-child(1) {
  background: #f4f7ff;
}
.dashboard-page .kanban-column:nth-child(2) {
  background: #f2fbf6;
}
.dashboard-page .kanban-column:nth-child(3) {
  background: #fffaf1;
}
.dashboard-page .kanban-column:nth-child(4) {
  background: #faf6ff;
}
.dashboard-page .kanban-column:nth-child(5) {
  background: #fff5f6;
}
.dashboard-page .kanban-column:nth-child(6) {
  background: #f1fbfd;
}
.dashboard-page .kanban-column:nth-child(7) {
  background: #f8faed;
}
.dashboard-page .kanban-column:nth-child(8) {
  background: #fff7f1;
}
.dashboard-page .kanban-column:nth-child(9) {
  background: #f6f5ff;
}
.dashboard-page .kanban-column:nth-child(10) {
  background: #f3faf3;
}
.dashboard-page .kanban-column:nth-child(11) {
  background: #fff5f8;
}
.dashboard-page .kanban-column:nth-child(12) {
  background: #f1faff;
}
.dashboard-page .kanban-column:nth-child(13) {
  background: #faf8ef;
}
.dashboard-page .kanban-column:nth-child(14) {
  background: #f3f8fb;
}
.dashboard-page .kanban-column:nth-child(15) {
  background: #fff7ef;
}
.dashboard-page .kanban-column:nth-child(16) {
  background: #f3f6fd;
}
.dashboard-page .kanban-column:nth-child(17) {
  background: #f0f8f0;
}
.dashboard-page .kanban-column:nth-child(18) {
  background: #fff4f4;
}
.dashboard-page .kanban-column:nth-child(19) {
  background: #f7f3fd;
}
.dashboard-page .kanban-column:nth-child(20) {
  background: #f2faf8;
}
.dashboard-page .kanban-column:nth-child(21) {
  background: #f2f4fb;
}
.dashboard-page .kanban-column:nth-child(22) {
  background: #fcf6ef;
}
.dashboard-page .kanban-column:nth-child(23) {
  background: #f1faf5;
}
.dashboard-page .kanban-column:nth-child(24) {
  background: #f9f3fc;
}
.dashboard-page .kanban-column:nth-child(25) {
  background: #f1f8fa;
}
.dashboard-page .kanban-column-header:hover {
  filter: brightness(0.92);
}
.dashboard-page .kanban-column-header:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: -2px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}
.dashboard-page .kanban-column-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 24px;
  padding: 0 7px;
  color: #fff;
  background: var(--brand);
  border-radius: 999px;
  font-size: 12px;
}
.dashboard-page .kanban-column-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 130px;
  max-height: 65vh;
  padding: 12px;
  overflow-y: auto;
}
.dashboard-page .kanban-order-card {
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 14px;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: var(--rsm);
  box-shadow: 0 1px 2px rgba(15, 35, 75, 0.05);
}
.dashboard-page .kanban-order-id {
  display: block;
  width: fit-content;
  padding: 0;
  color: var(--brand);
  background: transparent;
  border: 0;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 700;
  text-align: left;
  cursor: pointer;
  word-break: break-word;
}
.dashboard-page .kanban-order-id:hover,
.dashboard-page .kanban-order-id:focus-visible {
  color: var(--brand-dark);
  text-decoration: underline;
  outline: none;
}
.dashboard-page .kanban-order-name {
  color: var(--ink);
  font-size: 14px;
  line-height: 1.4;
  word-break: break-word;
}
.dashboard-page .kanban-load-more {
  width: 100%;
  padding: 9px 12px;
  color: var(--brand);
  background: #fff;
  border: 1px solid var(--border);
  border-radius: var(--rsm);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.dashboard-page .kanban-load-more:hover:not(:disabled),
.dashboard-page .kanban-load-more:focus-visible {
  color: var(--brand-dark);
  border-color: var(--brand);
  outline: none;
}
.dashboard-page .kanban-load-more:disabled {
  cursor: wait;
  opacity: 0.65;
}
.dashboard-page .kanban-empty {
  margin: auto 0;
  padding: 20px 0;
}
@media (max-width: 680px) {
  .dashboard-page {
    padding: 16px;
  }
  .dashboard-page .kanban-column-body {
    max-height: 46vh;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/style.scss"],"names":[],"mappings":"AAEA;EACE,wBAAA;EACA,6BAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EAEA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,gCAAA;AAFF;AAIE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AAFJ;AAII;EACE,SAAA;EACA,iBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;AAFN;AAKI;EACE,eAAA;EACA,mBAAA;EACA,eAAA;AAHN;AAMI;;EAEE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAJN;AAOI;;EAEE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,wBAAA;EACA,4BAAA;EACA,+BAAA;EACA,oBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AALN;AAOM;;;EAEE,mBAAA;EACA,0BAAA;EACA,aAAA;AAJR;AAQI;EACE,WAAA;EACA,wBAAA;EACA,0BAAA;AANN;AAWE;EACE,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,gBAAA;EACA,4CAAA;AATJ;AAWI;EACE,sCAAA;AATN;AAWM;EACE,gCAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AATR;AAcE;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,8BAAA;AAZJ;AAgBE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,+BAAA;EACA,uBAAA;EACA,0BAAA;AAdJ;AAiBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,4BAAA;EACA,SAAA;EACA,sCAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;AAfJ;AAkBE;EACE,mBAAA;AAhBJ;AAmBE;EACE,mBAAA;AAjBJ;AAoBE;EACE,mBAAA;AAlBJ;AAqBE;EACE,mBAAA;AAnBJ;AAsBE;EACE,mBAAA;AApBJ;AAuBE;EACE,mBAAA;AArBJ;AAwBE;EACE,mBAAA;AAtBJ;AAyBE;EACE,mBAAA;AAvBJ;AA0BE;EACE,mBAAA;AAxBJ;AA2BE;EACE,mBAAA;AAzBJ;AA4BE;EACE,mBAAA;AA1BJ;AA6BE;EACE,mBAAA;AA3BJ;AA8BE;EACE,mBAAA;AA5BJ;AA+BE;EACE,mBAAA;AA7BJ;AAgCE;EACE,mBAAA;AA9BJ;AAiCE;EACE,mBAAA;AA/BJ;AAkCE;EACE,mBAAA;AAhCJ;AAmCE;EACE,mBAAA;AAjCJ;AAoCE;EACE,mBAAA;AAlCJ;AAqCE;EACE,mBAAA;AAnCJ;AAsCE;EACE,mBAAA;AApCJ;AAuCE;EACE,mBAAA;AArCJ;AAwCE;EACE,mBAAA;AAtCJ;AAyCE;EACE,mBAAA;AAvCJ;AA0CE;EACE,mBAAA;AAxCJ;AA2CE;EACE,mBAAA;AAzCJ;AA4CE;EACE,mBAAA;AA1CJ;AA6CE;EACE,mBAAA;AA3CJ;AA8CE;EACE,mBAAA;AA5CJ;AA+CE;EACE,mBAAA;AA7CJ;AAgDE;EACE,mBAAA;AA9CJ;AAiDE;EACE,mBAAA;AA/CJ;AAkDE;EACE,mBAAA;AAhDJ;AAmDE;EACE,mBAAA;AAjDJ;AAoDE;EACE,mBAAA;AAlDJ;AAqDE;EACE,mBAAA;AAnDJ;AAsDE;EACE,mBAAA;AApDJ;AAuDE;EACE,mBAAA;AArDJ;AAwDE;EACE,mBAAA;AAtDJ;AAyDE;EACE,mBAAA;AAvDJ;AA0DE;EACE,mBAAA;AAxDJ;AA2DE;EACE,mBAAA;AAzDJ;AA4DE;EACE,mBAAA;AA1DJ;AA6DE;EACE,mBAAA;AA3DJ;AA8DE;EACE,mBAAA;AA5DJ;AA+DE;EACE,mBAAA;AA7DJ;AAgEE;EACE,mBAAA;AA9DJ;AAiEE;EACE,mBAAA;AA/DJ;AAkEE;EACE,mBAAA;AAhEJ;AAmEE;EACE,mBAAA;AAjEJ;AAoEE;EACE,wBAAA;AAlEJ;AAqEE;EACE,+BAAA;EACA,oBAAA;EACA,6BAAA;EACA,4BAAA;AAnEJ;AAsEE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,wBAAA;EACA,oBAAA;EACA,eAAA;AApEJ;AAuEE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;AArEJ;AAwEE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,aAAA;EACA,gBAAA;EACA,+BAAA;EACA,yBAAA;EACA,4CAAA;AAtEJ;AAyEE;EACE,cAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AAvEJ;AA0EE;;EAEE,wBAAA;EACA,0BAAA;EACA,aAAA;AAxEJ;AA2EE;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AAzEJ;AA4EE;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,+BAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AA1EJ;AA6EE;;EAEE,wBAAA;EACA,0BAAA;EACA,aAAA;AA3EJ;AA8EE;EACE,YAAA;EACA,aAAA;AA5EJ;AA+EE;EACE,cAAA;EACA,eAAA;AA7EJ;AAgFE;EA1bF;IA2bI,aAAA;EA7EF;EA+EE;IACE,gBAAA;EA7EJ;AACF","sourcesContent":["// style.scss\n\n.dashboard-page {\n  --brand: rgb(0, 65, 149);\n  --brand-dark: rgb(0, 48, 112);\n  --surface: #F5F8FF;\n  --surface-2: #EEF3FC;\n  --border: #E2E8F4;\n  --ink: #172B4D;\n  --muted: #4B5768;\n  --success: #1F9D6B;\n  --warning: #C08A1E;\n  --danger: #C24444;\n  --r: 12px;\n  --rsm: 8px;\n  --rxs: 6px;\n\n  padding: 24px;\n  min-height: 100%;\n  background: #fff;\n  font-family: 'Inter', sans-serif;\n\n  .dashboard-heading {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    margin-bottom: 28px;\n    flex-wrap: wrap;\n\n    h1 {\n      margin: 0;\n      color: var(--ink);\n      font-family: 'Inter', sans-serif;\n      font-weight: 600;\n      font-size: 26px;\n      letter-spacing: -0.01em;\n    }\n\n    p {\n      margin: 6px 0 0;\n      color: var(--muted);\n      font-size: 14px;\n    }\n\n    .dashboard-heading-actions,\n    .dashboard-view-buttons {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      flex-wrap: wrap;\n    }\n\n    .dashboard-refresh-button,\n    .dashboard-view-button {\n      display: inline-flex;\n      align-items: center;\n      gap: 8px;\n      padding: 8px 14px;\n      color: var(--brand-dark);\n      background: var(--surface-2);\n      border: 1px solid var(--border);\n      border-radius: 999px;\n      cursor: pointer;\n      font-size: 13px;\n      font-weight: 500;\n      white-space: nowrap;\n\n      &:hover,\n      &:focus-visible {\n        color: var(--brand);\n        border-color: var(--brand);\n        outline: none;\n      }\n    }\n\n    .dashboard-view-button.is-active {\n      color: #fff;\n      background: var(--brand);\n      border-color: var(--brand);\n    }\n\n  }\n\n  .dashboard-panel {\n    margin-bottom: 24px;\n    border-radius: var(--r);\n    border: 1px solid var(--border);\n    background: #fff;\n    box-shadow: 0 1px 2px rgba(15, 35, 75, 0.05);\n\n    .ant-card-head {\n      border-bottom: 1px solid var(--border);\n\n      .ant-card-head-title {\n        font-family: 'Inter', sans-serif;\n        font-weight: 600;\n        color: var(--ink);\n        font-size: 15px;\n      }\n    }\n  }\n\n  .dashboard-kanban {\n    display: flex;\n    gap: 16px;\n    align-items: start;\n    padding-bottom: 10px;\n    overflow-x: auto;\n    overscroll-behavior-x: contain;\n    // scrollbar-width: thin;\n  }\n\n  .kanban-column {\n    flex: 0 0 280px;\n    min-width: 280px;\n    overflow: hidden;\n    border: 1px solid var(--border);\n    border-radius: var(--r);\n    background: var(--surface);\n  }\n\n  .kanban-column-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    padding: 15px 16px;\n    color: var(--brand-dark);\n    background: var(--surface-2);\n    border: 0;\n    border-bottom: 1px solid var(--border);\n    font-family: 'Inter', sans-serif;\n    font-size: 13px;\n    font-weight: 700;\n    text-transform: uppercase;\n    text-align: left;\n    cursor: pointer;\n    transition: filter 0.15s ease;\n  }\n\n  .kanban-column:nth-child(1) .kanban-column-header {\n    background: #e8f0ff;\n  }\n\n  .kanban-column:nth-child(2) .kanban-column-header {\n    background: #e8f8f1;\n  }\n\n  .kanban-column:nth-child(3) .kanban-column-header {\n    background: #fff3df;\n  }\n\n  .kanban-column:nth-child(4) .kanban-column-header {\n    background: #f4eaff;\n  }\n\n  .kanban-column:nth-child(5) .kanban-column-header {\n    background: #ffe9ec;\n  }\n\n  .kanban-column:nth-child(6) .kanban-column-header {\n    background: #e5f7fb;\n  }\n\n  .kanban-column:nth-child(7) .kanban-column-header {\n    background: #eef1d8;\n  }\n\n  .kanban-column:nth-child(8) .kanban-column-header {\n    background: #fce8d9;\n  }\n\n  .kanban-column:nth-child(9) .kanban-column-header {\n    background: #e9e7ff;\n  }\n\n  .kanban-column:nth-child(10) .kanban-column-header {\n    background: #e5f0e5;\n  }\n\n  .kanban-column:nth-child(11) .kanban-column-header {\n    background: #fff0f5;\n  }\n\n  .kanban-column:nth-child(12) .kanban-column-header {\n    background: #e6f5ff;\n  }\n\n  .kanban-column:nth-child(13) .kanban-column-header {\n    background: #f3edda;\n  }\n\n  .kanban-column:nth-child(14) .kanban-column-header {\n    background: #e7eff4;\n  }\n\n  .kanban-column:nth-child(15) .kanban-column-header {\n    background: #f6e8d5;\n  }\n\n  .kanban-column:nth-child(16) .kanban-column-header {\n    background: #e8eefa;\n  }\n\n  .kanban-column:nth-child(17) .kanban-column-header {\n    background: #e9f5e9;\n  }\n\n  .kanban-column:nth-child(18) .kanban-column-header {\n    background: #f8e9e9;\n  }\n\n  .kanban-column:nth-child(19) .kanban-column-header {\n    background: #eee9fa;\n  }\n\n  .kanban-column:nth-child(20) .kanban-column-header {\n    background: #e7f3f0;\n  }\n\n  .kanban-column:nth-child(21) .kanban-column-header {\n    background: #e6eaf7;\n  }\n\n  .kanban-column:nth-child(22) .kanban-column-header {\n    background: #f5eadf;\n  }\n\n  .kanban-column:nth-child(23) .kanban-column-header {\n    background: #e4f4ec;\n  }\n\n  .kanban-column:nth-child(24) .kanban-column-header {\n    background: #f1e8f8;\n  }\n\n  .kanban-column:nth-child(25) .kanban-column-header {\n    background: #e8f2f5;\n  }\n\n  .kanban-column:nth-child(1) {\n    background: #f4f7ff;\n  }\n\n  .kanban-column:nth-child(2) {\n    background: #f2fbf6;\n  }\n\n  .kanban-column:nth-child(3) {\n    background: #fffaf1;\n  }\n\n  .kanban-column:nth-child(4) {\n    background: #faf6ff;\n  }\n\n  .kanban-column:nth-child(5) {\n    background: #fff5f6;\n  }\n\n  .kanban-column:nth-child(6) {\n    background: #f1fbfd;\n  }\n\n  .kanban-column:nth-child(7) {\n    background: #f8faed;\n  }\n\n  .kanban-column:nth-child(8) {\n    background: #fff7f1;\n  }\n\n  .kanban-column:nth-child(9) {\n    background: #f6f5ff;\n  }\n\n  .kanban-column:nth-child(10) {\n    background: #f3faf3;\n  }\n\n  .kanban-column:nth-child(11) {\n    background: #fff5f8;\n  }\n\n  .kanban-column:nth-child(12) {\n    background: #f1faff;\n  }\n\n  .kanban-column:nth-child(13) {\n    background: #faf8ef;\n  }\n\n  .kanban-column:nth-child(14) {\n    background: #f3f8fb;\n  }\n\n  .kanban-column:nth-child(15) {\n    background: #fff7ef;\n  }\n\n  .kanban-column:nth-child(16) {\n    background: #f3f6fd;\n  }\n\n  .kanban-column:nth-child(17) {\n    background: #f0f8f0;\n  }\n\n  .kanban-column:nth-child(18) {\n    background: #fff4f4;\n  }\n\n  .kanban-column:nth-child(19) {\n    background: #f7f3fd;\n  }\n\n  .kanban-column:nth-child(20) {\n    background: #f2faf8;\n  }\n\n  .kanban-column:nth-child(21) {\n    background: #f2f4fb;\n  }\n\n  .kanban-column:nth-child(22) {\n    background: #fcf6ef;\n  }\n\n  .kanban-column:nth-child(23) {\n    background: #f1faf5;\n  }\n\n  .kanban-column:nth-child(24) {\n    background: #f9f3fc;\n  }\n\n  .kanban-column:nth-child(25) {\n    background: #f1f8fa;\n  }\n\n  .kanban-column-header:hover {\n    filter: brightness(0.92);\n  }\n\n  .kanban-column-header:focus-visible {\n    outline: 2px solid currentColor;\n    outline-offset: -2px;\n    border-top-right-radius: 10px;\n    border-top-left-radius: 10px;\n  }\n\n  .kanban-column-count {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 28px;\n    height: 24px;\n    padding: 0 7px;\n    color: #fff;\n    background: var(--brand);\n    border-radius: 999px;\n    font-size: 12px;\n  }\n\n  .kanban-column-body {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    min-height: 130px;\n    max-height: 65vh;\n    padding: 12px;\n    overflow-y: auto;\n  }\n\n  .kanban-order-card {\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n    padding: 14px;\n    background: #fff;\n    border: 1px solid var(--border);\n    border-radius: var(--rsm);\n    box-shadow: 0 1px 2px rgba(15, 35, 75, 0.05);\n  }\n\n  .kanban-order-id {\n    display: block;\n    width: fit-content;\n    padding: 0;\n    color: var(--brand);\n    background: transparent;\n    border: 0;\n    font-family: 'Inter', sans-serif;\n    font-size: 13px;\n    font-weight: 700;\n    text-align: left;\n    cursor: pointer;\n    word-break: break-word;\n  }\n\n  .kanban-order-id:hover,\n  .kanban-order-id:focus-visible {\n    color: var(--brand-dark);\n    text-decoration: underline;\n    outline: none;\n  }\n\n  .kanban-order-name {\n    color: var(--ink);\n    font-size: 14px;\n    line-height: 1.4;\n    word-break: break-word;\n  }\n\n  .kanban-load-more {\n    width: 100%;\n    padding: 9px 12px;\n    color: var(--brand);\n    background: #fff;\n    border: 1px solid var(--border);\n    border-radius: var(--rsm);\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n  }\n\n  .kanban-load-more:hover:not(:disabled),\n  .kanban-load-more:focus-visible {\n    color: var(--brand-dark);\n    border-color: var(--brand);\n    outline: none;\n  }\n\n  .kanban-load-more:disabled {\n    cursor: wait;\n    opacity: 0.65;\n  }\n\n  .kanban-empty {\n    margin: auto 0;\n    padding: 20px 0;\n  }\n\n  @media (max-width: 680px) {\n    padding: 16px;\n\n    .kanban-column-body {\n      max-height: 46vh;\n    }\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
